import { useState, useEffect } from "react";
import { PluginsValue } from "../contexts/plugins";
import { useContext } from "react";
const LoadScript = (plugin, version, component) => {
  return new Promise((resolve, reject) => {
    try {
      if (!!window[component]) {
        resolve(window[component].canvasPreview);
        return;
      }
    } catch (err) {
      console.log("Loading this again");
    }

    var script = document.createElement("script");
    script.src = `https://uploads.brevitybuilder.com/plugins/${plugin}/${version}/components/${component}/preview.js`;
    script.addEventListener("load", function () {
      if (window[component]) {
        resolve(window[component].canvasPreview);
      } else {
        reject();
      }
      reject();
    });
    script.addEventListener("error", function (e) {
      reject(e);
    });
    document.body.appendChild(script);
  });
};

export default function useDynamic({ plugin, name: component }) {
  const [holder, setHolder] = useState([() => <div>loading...</div>]);
  const plugins = useContext(PluginsValue);
  useEffect(() => {
    if (plugins) {
      const _plugin = plugins[plugin];
      if (!_plugin) {
        return;
      }
      LoadScript(_plugin.plugin.name, _plugin.version, component)
        .then((param) => {
          setHolder([param]);
        })
        .catch(() => {
          setHolder([() => <div>Error Loading Element</div>]);
        });
    }
  }, [plugin, component, plugins]);

  return holder[0];
}
